import * as actionTypes from './actionTypes';

export const fetchPermissionTree = sid => ({
  type: actionTypes.FETCH_PERMISSION_TREE,
  sid,
});
export const fetchPermissionTreeSuccess = () => ({
  type: actionTypes.FETCH_PERMISSION_TREE_SUCCESS,
});

export const setPermissionTree = permissionTree => ({
  type: actionTypes.SET_PERMISSION_TREE,
  permissionTree,
});

export const fetchAllBySid = sid => ({
  type: actionTypes.FETCH_BY_SID,
  sid,
});
export const fetchAllBySidSuccess = ids => ({
  type: actionTypes.FETCH_BY_SID_SUCCESS,
  ids,
});

export const fetchAclObjectIdentities = () => ({
  type: actionTypes.FETCH_ACL_OBJECT_IDENTITIES,
});
export const fetchAclObjectIdentitiesSuccess = (entities, ids) => ({
  type: actionTypes.FETCH_ACL_OBJECT_IDENTITIES_SUCCESS,
  entities,
  ids,
});

export const fetchAllAclEntityIdToOidMap = () => ({
  type: actionTypes.FETCH_ACL_ENTITY_ID_TO_OID_INDEX,
});
export const fetchAllAclEntityIdToOidMapSuccess = index => ({
  type: actionTypes.FETCH_ACL_ENTITY_ID_TO_OID_INDEX_SUCCESS,
  index,
});

export const fetchAclSids = () => ({
  type: actionTypes.FETCH_ACL_SIDS,
});
export const fetchAclSidsSuccess = (entities, ids) => ({
  type: actionTypes.FETCH_ACL_SIDS_SUCCESS,
  entities,
  ids,
});

export const fetchPermissionsBySid = sid => ({
  type: actionTypes.FETCH_PERMISSIONS,
  sid,
});
export const fetchPermissionsBySidSuccess = (entities, ids, sid) => ({
  type: actionTypes.FETCH_PERMISSIONS_SUCCESS,
  entities,
  ids,
  sid,
});

export const setPermissions = permissions => ({
  type: actionTypes.SET_PERMISSIONS,
  permissions,
});

export const updatePermission = permission => ({
  type: actionTypes.UPDATE,
  permission,
});
export const updatePermissionSuccess = permission => ({
  type: actionTypes.UPDATE_SUCCESS,
  permission,
});

export const deletePermission = permission => ({
  type: actionTypes.DELETE,
  permission,
});
export const deletePermissionSuccess = permission => ({
  type: actionTypes.DELETE_SUCCESS,
  permission,
});

export const setEditingRoleId = roleId => ({
  type: actionTypes.SET_EDITING_ROLE_ID,
  roleId,
});

export const setEditingSid = sid => ({
  type: actionTypes.SET_EDITING_SID,
  sid,
});
